// extracted by mini-css-extract-plugin
export default {"wrapper":"BarcodeImages_wrapper__dWx0N","imageWrapper":"BarcodeImages_imageWrapper__3ii6H","image":"BarcodeImages_image__N1kS+","flex":"BarcodeImages_flex__eQJ-h"};